<div class="container-fluid">
    <div class="row-fluid heading">
        <div class="span6 heading-container">
            <div class="heading-content">
                <div id="cookieText">
                    Cookies
                </div>
                <div id="cookietime">
                    Last updated: 04 October 2024
                </div>
            </div>
        </div>
        <div class="span6 heading-preferences move-right">
            <button
                type="button"
                onclick="OneTrust.ToggleInfoDisplay()"
                class="hover-link">Manage cookie preferences</button>
        </div>
    </div>
    <div class="title"><span class="cookieHeading">Cookie Notice</span></div>
    <!--  -->
    <div class="cookie-accordion" id="accordionFlushExample">
        <div class="accordion-container">
            <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button " [class.closed]="!isaccordian1open"
                        (click)="isaccordian1open = !isaccordian1open" type="button" data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        What is a cookie?
                    </button>
                </h2>
            </div>
            <div class="accordion-body" *ngIf="isaccordian1open">
              <p>
                A cookie is a small text file placed on your device by the websites that you visit. Cookies are
                then sent back to the website on each subsequent visit, or to another webpage that recognizes
                that cookie. Cookies are used in order to make the website work, or to work more efficiently,
                as well as to provide information to the owners of the website. Such information may be used
                to provide a more personalized and responsive service. Cookies may be either first party cookies
                set directly by us to your device, or third-party cookies set by a third-party provider on our
                behalf. Whenever you use this system, information may be collected through the use of cookies
                and other similar technologies (e.g., web beacons, tags, scripts, local storage).
                <br /><br />
                Controller of the Cookies: Deloitte Touche Tohmatsu Limited or Deloitte Global Services Limited with registered office at 1 New Street Square, London, United Kingdom, EC4A 3HQ
                decided to use the cookies specified on the website.

              </p>
            </div>
        </div>
        <div class="accordion-container">
            <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingTwo">
                    <button class="accordion-button " type="button" [class.closed]="!isaccordian2open"
                        (click)="isaccordian2open = !isaccordian2open" data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        Cookies we use and why
                    </button>
                </h2>
            </div>
            <div class="accordion-body" *ngIf="isaccordian2open">
                <p>This system uses cookies and web beacons that are classified into the following categories:</p><br>
                    <div class="accordion-para">
                        <p>
                          • “Strictly Necessary” which are necessary for the system to function and cannot be
                          switched off in our systems. They are set in response to actions made by you which
                          amount to a request for services, such as authenticating into the system or managing
                          your session with the requested service.<br>
                          <br>
                          • “Analytics and Performance” which are necessary for our systems to measure audience
                          and usage statistics, as well as content consumption. These enable us to obtain relevant
                          usage information to produce internal analytics so we can monitor and improve the
                          performance of our systems.<br>
                          <br>
                          • “Preference or functionality cookies” which allow websites to remember the users’
                          respective site preferences and choices (with the exclusion of essential functional
                          cookies).<br>
                          <br> 
                        </p> 
                    </div> 
                <p>
                  To view a list of the cookies that are used by the system, <button
                      type="button"
                      onclick="OneTrust.ToggleInfoDisplay()"
                      class="hover-link">click here</button>
                </p>
            </div>
        </div>
        <div class="accordion-container">
            <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingThree">
                    <button class="accordion-button " [class.closed]="!isaccordian3open"
                        (click)="isaccordian3open = !isaccordian3open" type="button" data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        How long will cookies remain on my device?
                    </button>
                </h2>
            </div>
            <div class="accordion-body" *ngIf="isaccordian3open">
                <p>The length of time cookies will stay on your device will depend on whether it is a “persistent” 
                    or “session” cookie. A persistent cookie will be stored by a web browser and will remain valid 
                    until its set expiration date, unless deleted by you before the expiration date. A session cookie, 
                    on the other hand, will expire at the end of your web session, when the web browser is closed.</p>
            </div>

        </div>
    </div>
</div>
